// Watches for errors the page shows and files a bug report for each one
// (services/autoBugReport.js), then says so, so nobody is surprised by a
// ticket they did not write.

import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { autoBugEnabled, startAutoBugReports } from '../../services/autoBugReport';

export default function AutoBugReporter() {
    const [filed, setFiled] = useState(null);

    useEffect(() => {
        if (!autoBugEnabled()) return undefined;
        return startAutoBugReports({ onFiled: setFiled });
    }, []);

    return (
        <Snackbar open={Boolean(filed)} autoHideDuration={8000} onClose={() => setFiled(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} data-bug-report-exclude="">
            <Alert severity="info" variant="filled" onClose={() => setFiled(null)} sx={{ maxWidth: 440 }}
                data-auto-bug-ignore="">
                That error has been reported to the team automatically. Nothing else you need to do.
            </Alert>
        </Snackbar>
    );
}
